import di from 'di'
import RealtimeSubject from 'common/js/enum/RealtimeSubject';
import { ProductStoreAction } from 'common/js/store/products';
import { PromotionStoreAction } from 'common/js/store/promotions';
import { AssetStoreAction } from 'common/js/store/assets';
import { RealtimeClient } from 'common/js/service/RealtimeClient';

export default function(app){

    const config = di.get('config');
    const store = di.get('store');

    const client = new RealtimeClient({
        host: config.realtime.host,
        path: config.realtime.path,
        logger: di.get('logger')
    });

    client
        .handler(RealtimeSubject.PRODUCT, payload => store.dispatch(ProductStoreAction.EXECUTE_PRODUCTS_OPERATION, payload))
        .handler(RealtimeSubject.PRODUCT_CATEGORY, payload => store.dispatch(ProductStoreAction.EXECUTE_PRODUCTS_OPERATION, payload))
        .handler(RealtimeSubject.PRODUCT_PRICE, payload => store.dispatch(ProductStoreAction.EXECUTE_PRODUCTS_OPERATION, payload))
        .handler(RealtimeSubject.PRODUCT_COLLECTION, payload => store.dispatch(ProductStoreAction.EXECUTE_PRODUCTS_OPERATION, payload))

        .handler(RealtimeSubject.PROMOTION, payload => store.dispatch(PromotionStoreAction.EXECUTE_PROMOTIONS_OPERATION, payload))
        .handler(RealtimeSubject.ASSET, payload => store.dispatch(AssetStoreAction.EXECUTE_ASSETS_OPERATION, payload))

        .handler(RealtimeSubject.SERVER, () => document.location.reload());

    di.set('realtime', client);
}